import {initializeApp} from "firebase/app";
import {getDatabase} from "firebase/database";
import {getMessaging, isSupported} from "firebase/messaging";
import {getFirestore} from "firebase/firestore";
import {browserLocalPersistence, getAuth, setPersistence} from "firebase/auth";

// Production Firebase project. Used unless a build sets its own project.
const productionConfig = {
    apiKey: "AIzaSyBinkf_bzky3TbUrXbcv6XkfRqAsbm2CsA",
    authDomain: "teache-39152.firebaseapp.com",
    databaseURL: "https://teache-39152-default-rtdb.firebaseio.com",
    projectId: "teache-39152",
    storageBucket: "teache-39152.appspot.com",
    messagingSenderId: "822655888239",
    appId: "1:822655888239:web:25e0e34919b949b962d69a",
    measurementId: "G-LG6D5L9QJK",
};

// Staging builds set REACT_APP_FIREBASE_PROJECT_ID (and the other values) so
// their messages live in a separate Firebase project and never reach
// production. All values then come from the environment, never mixed with
// production's.
const envProjectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
const firebaseConfig = envProjectId
    ? {
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || `${envProjectId}.firebaseapp.com`,
        databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || `https://${envProjectId}-default-rtdb.firebaseio.com`,
        projectId: envProjectId,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_FIREBASE_APP_ID,
    }
    : productionConfig;

const firebaseApp = initializeApp(firebaseConfig);
const database = getDatabase(firebaseApp);
const firestore = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);

let messaging = {}

if (
    isSupported() &&
    'Notification' in window &&
    'serviceWorker' in navigator &&
    'PushManager' in window
) {
    messaging = getMessaging(firebaseApp);
}

setPersistence(auth, browserLocalPersistence).catch(() => {
});

export {database, messaging, firestore, auth};
